export interface IHrisAttributeModel {
	name: string;
	type: string;
	columnIndex: number;
}

export interface IHrisColumnMapping {
	property: HrisExpectedColumnType;
	columnName: string;
	allowEmptyValues: boolean;
}

export enum HrisExpectedColumnType {
	EmployeeId = 1,
	Email = 2,
	FirstName = 3,
	LastName = 4,
	Name = 5,
	ManagerId = 6,
}
